<template>
  <v-container grid-list-md :class="['pa-0']">
    <v-layout row wrap>
      <v-flex sm6 md3>
        <v-btn aria-label="charts" dark block :color="getColorScheme()" :to="getBpi()" :title="$lang.viewCharts" :class="['mx-0']">
          <v-icon>{{ $root.config.appIcon }}</v-icon>
          <span :class="['mx-2']" v-html="$lang.viewCharts" />
          <v-icon>mdi-chevron-double-right</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex>
        <external-links :class="['mt-3']" :title="$lang.externalLinksTitle" :sub-title="$lang.externalLinksSubTitle" />
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import methods from '../mixins/methods'

export default {
  name: 'Index',
  mixins: [
    methods
  ]
}
</script>



// WEBPACK FOOTER //
// src/pages/index.vue